import {Country, UserInput} from "../../http/protocol";
import {UseFormRegister} from "react-hook-form/dist/types/form";
import {FieldErrors} from "react-hook-form/dist/types/errors";
import {RegisterOptions} from "react-hook-form/dist/types/validator";
import {useSelector} from "react-redux";
import {AppState} from "../../RootReducer";
import {selectText} from "../../user/ui/utils";
import DOWN_ARROW from "../../assets/down_arrow.svg";
import {InputError} from "./InputError";
import * as React from "react";
import {getContainer} from "../../ioc/IOCSetup";

export const toTranslation = (c: Country) => {
    let locale = getContainer().getSettingsService().getActiveLocale().code;
    let translation = c.translations?.[locale]
    if (!translation) {
        translation = c.translations?.["en"];
    }
    return translation;
}
export const UserDetailsCountrySelect = (props: { input: UserInput, name: string, register: UseFormRegister<any>, errors: FieldErrors<any>, options: RegisterOptions }) => {
    const {input, name, register, errors, options} = props;
    const countries = useSelector((app: AppState) => app.journey.journey?.countries ?? [])
    const hasError = !!errors[name]
    const {nameText, invalidText, helpText} = selectText(name);
    const country = useSelector((app: AppState) => app.user.user?.country) 

    return (
        <div className={"form-group " + (hasError ? "has-error" : "")}>
            <label id={name} className={"forms-label"} htmlFor={name}>{nameText}</label>
            <select className={`form-control`}
                    style={{backgroundImage: `url(${DOWN_ARROW})`}}
                    defaultValue={country}
                    {...register(name, options)}
            >
                {countries.map((c) => (
                    <option key={c.alpha2} value={c.alpha2}>{toTranslation(c)}</option>
                ))}
            </select>

            {helpText.length > 0 && !hasError && <span className="help-block">{helpText}</span>}
            {hasError && <InputError name={name} errors={errors} invalidText={invalidText}/>}
        </div>
    )
}